var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to.startsWith('http'))?_c('a',{attrs:{"href":_vm.to,"target":_vm.target}},[_vm._t("default")],2):_c('nuxt-link',_vm._b({},'nuxt-link',_vm.vProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }